export default __webpack_public_path__ + "static/media/BA2.9cb7cb7d.jpg";